export default {
  phone(phone) {
    return /^1(3|4|5|6|7|8|9)\d{9}$/.test(phone);
  },
  email(email) {
    return /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(
      email
    );
  },
  idCard(idcard) {
    return /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(
      idcard
    );
  },
  desensitization(str, beginLen, endLen) {
    var len = str.length;
    var firstStr = str.substr(0, beginLen);
    var lastStr = str.substr(endLen);
    var middleStr = str
      .substring(beginLen, len - Math.abs(endLen))
      .replace(/[\s\S]/gi, "*");
    return firstStr + middleStr + lastStr;
  }
};
